import axiosInstance from '../../../config/axiosInstance';
const  SupplierDocumentService = {
    async GetAllSupplierDocuments(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/GetAllSupplierDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
           
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteSupplierDocument(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/DeleteSupplierDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default SupplierDocumentService;